"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosaPlatforms = void 0;
var PosaPlatforms;
(function (PosaPlatforms) {
    PosaPlatforms["EPIC"] = "EPIC";
    PosaPlatforms["MOBILE"] = "MOBILE";
    PosaPlatforms["PSN"] = "PSN";
    PosaPlatforms["SWITCH"] = "SWITCH";
    PosaPlatforms["XBL"] = "XBL";
})(PosaPlatforms = exports.PosaPlatforms || (exports.PosaPlatforms = {}));
//# sourceMappingURL=types.js.map